module.exports = __webpack_public_path__ + "img/content.fb466a98.png";